module.exports = __webpack_public_path__ + "media/components/app-store/static/s5-77ffbe5db705a014f7ba9ba3593ef452.jpg";